export default __webpack_public_path__ + "597250b3310087459f7bf5d300f3a8c0.png";